<template>
  <v-container ref="certification">
    <div :class="$vuetify.breakpoint.mdAndUp ? 'display-1' : 'title'">
      Certifications
    </div>

    <v-divider
      class="pb-3"
    />

    <template v-if="certifications && certifications.length">
      <v-row
        v-for="(item, key) in certifications"
        :key="`Item${key}`"
      >
        <v-col
          cols="6"
          md="3"
        >
          {{ item.certification.name }}
        </v-col>
        <v-col
          cols="6"
          md="9"
        >
          <div
            class="pb-2"
            :class="$vuetify.breakpoint.mdAndUp ? 'body-1' : 'body-2'"
          >
            {{ item.certified_date | dateFormatLong }}
          </div>
        </v-col>
      </v-row>
    </template>

    <template v-else>
      <span>No certifications to display.</span>
    </template>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import dateFormat from '@/mixins/dateFormat';

export default {
  name: 'Certification',

  mixins: [dateFormat],

  computed: {
    ...mapState({
      user: (state) => state.account.user,
    }),

    certifications() {
      let list = [];
      // const converter = {
      //   0: 'SCC Individual Certified',
      //   1: 'Certified Coach',
      //   2: 'Advanced Coach',
      //   3: 'Master Coach',
      // };
      if (this.user && (this.user.certifications && this.user.certifications.length)) {
        // list = this.user.certifications.map((el) => {
        //   let unit;
        //   if (el && el.certification.id === 'indiv_coaching') {
        //     unit = el;
        //     unit.certification.name = converter[`${el.level}`];
        //   } else {
        //     unit = el;
        //   }
        //   return unit;
        // });
        list = this.user.certifications;
      }
      return list;
    },
  },
};
</script>
